import React from 'react';
import { FaStar } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';

function Stars({ stars, rating }) {
    return (
        <div className="App">
            {[...Array(5)].map((star, index) => {
                const ratingValue = index + 1;

                return (
                    <label key={uuidv4()}>
                        <FaStar className="star" color={ratingValue <= rating || ratingValue <= stars ? '#ffc107' : '#e4e5e9'} size={100} />
                    </label>
                );
            })}
        </div>
    );
}

export default Stars;
